import { BaseModel } from '@/modules/core/app/models/abstracts/BaseModel';

export class StripeInvoiceMetadata extends BaseModel {
  public dealID: number;

  /**
   * @deprecated - use property_payment_method on deal instead
   */
  public processedWithUplift?: boolean;

  constructor(model: Partial<StripeInvoiceMetadata> = {}) {
    super(model);

    this.dealID = model.dealID as number;
  }
}
